<script>
  export let value = "";

  import {Input} from 'sveltestrap';
</script>

<Input type="number" step="any" bind:value={value} />